import { BaseService } from './BaseService'

const SELECT_SPECIAL_MODE_PATH = '/special-mode/select'

class SpecialModeService extends BaseService {
  select (code) {
    return this.post(SELECT_SPECIAL_MODE_PATH, { code })
  }

  clear () {
    return this.post(SELECT_SPECIAL_MODE_PATH, { code: '' })
  }
}

export default new SpecialModeService()
